export const sendGAEvent = (eventName, params = {}) => {
    // console.log('eventName',eventName);
    // console.log('params',params);
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};